import {
	AbstractControl,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';

/**
 * Returns a required validator allowing to show a specific error message if
 * validation fails.
 * @param errorKey The key of the entry of the error message in the i18n maps
 */
export function requiredCustom( errorKey: string ): ValidatorFn {
	function removeRequiredError( control: AbstractControl ): ValidationErrors {
		let errors: ValidationErrors = control.errors;
		if ( errors && 'required' in errors ) {
			delete errors.required;
			control.setErrors( errors );
		}

		return control.errors;
	}


	return ( control: AbstractControl ): ValidationErrors | null => {
		// required validator is added to show the "field is required" indicator at the label
		// ( condition is checked by FormUtils.hasRequiredValidator )
		control.addValidators( Validators.required );

		const isValid = !!control?.value?.length;

		// delete errors of Validators.required to prevent interference (immediate and delayed, due to race conditions)
		let errors: ValidationErrors = removeRequiredError( control );

		const timeout = setTimeout( () => {
			clearTimeout( timeout );
			errors = removeRequiredError( control );
		}, 0 );

		return isValid
					 ? null
					 : { ...errors, [ errorKey ]: true }; // makes sure, that error of other validators aren't lost
	};
}
